import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { mediaLabel } from "../../../backendApi/CollectionApi";
import { Link } from "../../Link";
import { pushCollectionAction } from "../CollectionUtils";
export const CollectionItemSpecs = (param)=>{
    let { item, className } = param;
    const { title, medium, languages, publicationYear, mediumDescription, originalUrl } = item;
    const push = pushCollectionAction();
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "ci__spec spec--medium",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "spec__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                width: "1.5rem",
                                height: "1.5rem",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--library"
                                })
                            }),
                            "Type"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "spec__value",
                        children: mediaLabel[medium]
                    })
                ]
            }),
            (languages === null || languages === void 0 ? void 0 : languages.length) > 0 && /*#__PURE__*/ _jsxs("div", {
                className: "ci__spec spec--language",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "spec__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                width: "1.5rem",
                                height: "1.5rem",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--languages"
                                })
                            }),
                            languages.length == 1 ? "Taal" : "Talen"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "spec__value",
                        children: languages.join(", ")
                    })
                ]
            }),
            publicationYear > 0 && /*#__PURE__*/ _jsxs("div", {
                className: "ci__spec",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "spec__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "icon--calendar",
                                width: "1.5rem",
                                height: "1.5rem",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--calendar"
                                })
                            }),
                            "Gepubliceerd in"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "spec__value",
                        children: publicationYear
                    })
                ]
            }),
            mediumDescription && /*#__PURE__*/ _jsxs("div", {
                className: "ci__spec spec--format",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "spec__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                width: "1.5rem",
                                height: "1.5rem",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--pencil-ruler"
                                })
                            }),
                            "Formaat"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "spec__value",
                        children: mediumDescription
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "ci__view-all c-external__link",
                children: [
                    "Bekijk ",
                    /*#__PURE__*/ _jsxs(Link, {
                        url: originalUrl,
                        handle: ()=>push("Bekijk alle specificaties", title),
                        children: [
                            "alle specificaties",
                            /*#__PURE__*/ _jsx("svg", {
                                width: "1.5rem",
                                height: "1.5rem",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--external"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
